import { getInstance } from './axios-instance';

const B2C = 919;

async function getTags() {
	const url = `/projects/${B2C}/repository/tags`;
	let request;

	request = await getInstance().get(url);

	let tags: Array<any> = request.data;
	tags = tags.filter((el) => Number(el.name.replaceAll('.', '')) >= 10028000);

	tags = tags.sort(function (a, b) {
		a = Number(a.name.replaceAll('.', ''));
		b = Number(b.name.replaceAll('.', ''));

		if (a < b) {
			return 1;
		}
		if (a > b) {
			return -1;
		}
		return 0;
	});

	return tags;
}

function sendBuild(clients: Array<string>, workflow: string, target: string, sequential: string, releaseNotes: string, automaticRelease: boolean) {
	clients.forEach(async (client) => {
		let message = `${workflow.includes('ios-export-test') ? 'Teste' : 'Cliente'} ${client.toUpperCase()}`;

		if (automaticRelease) {
			message += ` - Liberação Automática`;
		} else if (releaseNotes) {
			message += ` - Liberação Manual`;
		}

		const environments = [
			{
				mapped_to: 'CLIENTE',
				value: client.toLowerCase(),
				is_expand: true,
			},
			{
				mapped_to: 'AUTOMATIC_RELEASE',
				value: automaticRelease.toString(),
				is_expand: true,
			},
		];

		if (releaseNotes) {
			environments.push({
				mapped_to: 'RELEASE_NOTES',
				value: releaseNotes,
				is_expand: true,
			});
		}

		const params: any = {
			hook_info: {
				type: 'bitrise',
			},
			build_params: {
				commit_message: message,
				workflow_id: workflow,
				environments,
			},
		};

		const tagRegex = new RegExp(/^(1.00.)([0-9]){2}(.)([0-9]){3}/g);

		if (tagRegex.test(target)) {
			params.build_params.tag = target;
		} else {
			params.build_params.branch = target;
		}

		if (sequential) {
			params.build_params.environments.push({
				mapped_to: 'SEQUENCIAL',
				value: sequential,
				is_expand: true,
			});
		}

		const response = await getInstance(true).post(`${window.RUNTIME_CONFIG.REACT_APP_BITRISE_API}/apps/${window.RUNTIME_CONFIG.REACT_APP_APP_ID}/builds`, params);

		return response.status;
	});
}

async function validateBitrise() {
	return getInstance(true).get(`${window.RUNTIME_CONFIG.REACT_APP_BITRISE_API}/apps/${window.RUNTIME_CONFIG.REACT_APP_APP_ID}/build-workflows`);
}

export { getTags, sendBuild, validateBitrise };
